var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ds-modal", {
    attrs: { open: _vm.showModal },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c("div", { staticClass: "modal-dialog go-modal-connect" }, [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("div", { staticClass: "modal-title" }, [
                    _vm._v(_vm._s(_vm.$t("scrap-agent.login"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn go-btn-icon close",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.handleCloseMail.apply(null, arguments)
                        },
                      },
                    },
                    [_c("i", { staticClass: "go-icon-24 go-icon-close" })]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "go-form-connect-login" }, [
                    _c("div", { staticClass: "go-form-header" }, [
                      _c("div", { staticClass: "go-brand" }, [
                        _c("div", { staticClass: "go-brand-symbol" }, [
                          _c("img", {
                            attrs: {
                              src: "https://dzh91b51qfr7r.cloudfront.net/social-channel-thumb/wordpress.png",
                              alt: "wordpress",
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("p", [_vm._v("Wordpress")]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "go-form-body" }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "go-form-connect-mode text-center" },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "google-btn",
                          attrs: { type: "button", "data-dismiss": "modal" },
                          on: {
                            click: function ($event) {
                              return _vm.openPopup()
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("scrap-agent.login")) +
                              "\n            "
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }